
export default {
  name: 'BlogArticleNav',
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    mqIsMobile() {
      return this.$mq === 'mobileXs' || this.$mq === 'mobile' || this.$mq === 'tablet';
    },
  },
  methods: {
    scrollToSection(anchor) {
      if (!anchor) return

      const el = document.querySelector(`#${anchor}`)

      if (!el) return

      const offset = this.mqIsMobile ? 50 : -50;

      window.scrollTo({
        behavior: 'smooth',
        top: el.offsetTop - offset,
        left: 0,
      });
    },

  },
}
